<template>
  <div class="race-question">
    <modal name="question" @before-close="onClose">
      <div style="padding: 20px;">
        <span> {{finishDate}} &nbsp;&nbsp;&nbsp;  {{race.duration}}&nbsp;&nbsp;&nbsp;   {{race.name}}</span>
            <p style="color: red">{{race.distance}}</p>
            <br/>
           <input type = "number" v-model="newdistance" id="newdistance" maxlength="255" name="newdistance" Placeholder="" style="width: 50%;"> Km
        <div>
          <br/>
          <button class="btn btn--primary" id="save-distance"  v-on:click="Save(newdistance)" style="float:none">Save</button>
        </div>
      </div>
    </modal>  
  </div>
  
</template>

<script>
  import RunnersByRaceService from '../../../services/runnersByRace'
  import { db } from '../../../firebase'

  export default {
    name: 'edit-distance',
    data: () => ({
        newdistance:'',
        finishDate: ''
    }),
    props:{
            race: {
                type:Object
            },
            show:false,
        },
    // firebase: {
    //   ${this.$fbDbEntry}: db.ref('${this.$fbDbEntry}')
    // },
    methods: {
      onClose() {
              this.$emit('closed', true)
      },
      openEditModal() {
        this.finishDate  = this.race.finishDate.slice(5)
        this.$modal.show('question')
      },
      Save (distance) {
        let  that = this
        let data1 = {
          raceId :  this.race.id,
          race :{
            runnerId: this.race.runnerId,
            distance: parseFloat(distance)*1000
          }
        }
        this.saveButton()
        RunnersByRaceService.updateDistance(data1).then((response) => {
          db.ref(`${this.$fbDbEntry}`).child(this.race.id).child("runners").child(this.race.runnerId).update({
            "distance": parseFloat(distance)*1000
          }).then(function(){
            let data = {
              raceId :  that.race.id,
              runnerId: that.race.runnerId,
              distance: parseFloat(distance)
            }
            that.resetSaveButton()
            that.$emit('saved', data)
            that.$modal.hide('question')
            that.newdistance = ''
          }).catch(function(error) {
            that.resetSaveButton()
            console.log(error)
          })
        })    
      },
    saveButton() {
        const btnsave = document.querySelector('#save-distance')
        btnsave.innerHTML = 'Saving...'
        btnsave.setAttribute('disabled', true)
      },
    resetSaveButton() {
        const btnsave = document.querySelector('#save-distance')
        btnsave.innerHTML = 'Save'
        btnsave.removeAttribute('disabled', true)
    },



    },
    created() {
     this.$watch('show', function (val) {
      })
    },
    
    watch: {
        show(oldVal, newVal) {
            if(this.show){
             this.openEditModal()
            }
        }
    },
  }
</script>
<style>
  .edit {
      background: red;
      padding: 0px 12px 0px 12px;
      color: white;
      border-radius: 10px;
      border-width: 1px;
      font-weight: bold;
    }

    #newdistance {
      height: 50px;
      border-radius: 10px;
      font-size: x-large;
      margin-left: 25px;
      text-align: center
    }
    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button { 
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        margin: 0; 
    }
    input:focus{
        outline: none;
    }

</style>



// WEBPACK FOOTER //
// EditDistance.vue?db044c3c